import React from "react";
import styles from "./styles.module.scss";
import { Paragraph, Asset, Icon } from "@sicredi/react";
import { useRouter } from "#/hocs/withRouter";
import { handlerNotRouters } from "#/utils/headerRoutes";
import { getWidth } from "#/utils/windowDimensionUtils";
import useScrollBehaviours from "#/hooks/useScrollBehaviours";
import useWindowDimensions from "#/hooks/useWindowDimensions";
import { FixedCategories } from "./MenuCategories";
import Sidebar from "../Sidebar/Sidebar";
import { returnOnScrollBehaviour } from "#/utils/formatters";
import { PAGE } from "#/constants";
import Auth from "../Auth/Auth";

declare global {
  interface Window {
    dataLayer: [Record<string, number | string>];
  }
}
export default function HeaderContainer() {
  const { handleGoNextPage } = useRouter();
  const { width, height } = useWindowDimensions();
  const { scrollY } = useScrollBehaviours();

  const tabs = [
    {
      id: 1,
      label: "Shopping",
      routerOrhref: "https://shopping.sicredi.com.br/",
    },
    {
      id: 2,
      label: "Parcerias e Descontos",
      routerOrhref: "https://parcerias.app.sicredi.com.br/",
    },
    {
      id: 3,
      label: "Viagens",
      routerOrhref: "",
    },
    {
      id: 4,
      label: "Imóveis e Veículos",
      routerOrhref: "https://imoveiseveiculos.app.sicredi.com.br/",
    },
  ];

  function handlerRouters(
    router: string,
    isRouter: boolean,
    label: string
  ): void {
    if (isRouter) {
      handleGoNextPage(router);
      return;
    }

    handlerNotRouters(router);
  }

  return (
    <div data-testid="header">
      <div className={styles["top-header"]} data-testid="header-tabs">
        <div className={styles.container}>
          <Paragraph
            size="x-small"
            style={{ fontStyle: "italic", margin: "auto" }}
          >
            Viagens Sicredi
          </Paragraph>
          <div className={styles["tab"]}>
            {tabs.map((elem: any) => (
              <button
                data-testid={`tab-button${elem.id}`}
                key={elem.id}
                className={styles["tablinks"]}
                onClick={() =>
                  handlerRouters(elem.routerOrhref, false, elem.label)
                }
                id={`default-${elem.id}`}
              >
                {elem.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      {getWidth(width, 1024) ? (
        <div className={styles["header-actions"]} data-testid="header-desktop">
          <div
            id="container-header-actions"
            data-testid="container-header-actions"
            className={styles.container}
            style={returnOnScrollBehaviour(scrollY)}
          >
            <div className={styles["main-header"]}>
              <div className={styles["margin-left"]} />
              <Asset
                data-testid="asset-desktop"
                name="sicredi-logo"
                width={150}
                height={45}
                style={{ cursor: "pointer" }}
                onClick={() => handleGoNextPage(PAGE.ROOT())}
              />

              <Auth />
              <div className={styles["margin-right"]} />
            </div>
            <div className={styles["header-menus"]}>
              <div className={styles.dropdown}>
                <nav
                  data-testid="nav-categories"
                  className={`${styles["outlined-button"]} ${styles.green}`}
                >
                  <Icon height={24} name="menu" />
                  Todas os departamentos
                  <Icon name="chevron-down" />
                </nav>
                <div
                  className={styles["dropdown-content"]}
                  style={{ maxHeight: height - 223 }}
                >
                  <FixedCategories />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles["header-actions"]} data-testid="header-mobile">
          <div
            id="container-header-actions-mobile"
            className={styles.container}
            style={returnOnScrollBehaviour(scrollY)}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "12px 24px 24px 24px",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "43%",
                }}
              >
                <Sidebar />
                <Asset
                  data-testid="asset-mobile"
                  style={{
                    margin: "0 10px 0 -15px",
                    cursor: "pointer",
                    padding: "0",
                  }}
                  name="sicredi-logo"
                  width={69}
                  height={15}
                  onClick={() => handleGoNextPage(PAGE.ROOT())}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  justifyItems: "flex-end",
                  width: "45%",
                }}
              >
                <Auth />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
